import React, { Component } from 'react'
import { connect } from 'react-redux'
import { reduxForm, Field } from 'redux-form'
// import * as actions from '../../actions'
import { renderTextField } from '../auth/form_helpers'

import '../../style/style.css';

import RaisedButton from 'material-ui/RaisedButton'
// import SelectField from 'material-ui/SelectField';
// import Menu from 'material-ui/Menu';
// import Popover, {PopoverAnimationVertical} from 'material-ui/Popover';
// import MenuItem from 'material-ui/MenuItem';
// import Checkbox from 'material-ui/Checkbox';
// import Divider from 'material-ui/Divider';
// import TextField from 'material-ui/TextField'
// import DatePicker from 'material-ui/DatePicker';
import Paper from 'material-ui/Paper';
// import TextField from 'material-ui/TextField';

// import * as actionCreator from '../../actions'

// const uuidv4 = require('uuid/v4');

const styles = {
  block: {
    maxWidth: 250,
  },
  checkbox: {
    marginBottom: 16,
  },
  pt15: {
    paddingTop: 15,
  },
};

// var validQTypes = []

class SettingForm extends Component {

  constructor(props) {
    super(props)

    this.state = {
      openPopover: false
    }
  }

  handlePopoverClick = (event) => {
    // This prevents ghost click.
    event.preventDefault();

    this.setState({
      openPopover: true,
      anchorEl: event.currentTarget,
    });
  }

  handleRequestPopoverClose = () => {
    this.setState({
      openPopover: false,
    });
  }

  componentDidMount() {
  }

  componentWillMount() {
  }

  componentWillUnmount() {
  }

  renderAlert() {
    if (this.props.errorMessage) {
      return <div className="alert alert-danger">
        <strong>Oops: </strong>{this.props.errorMessage}
      </div>
    }
  }

  renderAutomatedDisabler() {
    let thisYear = new Date()
    if (typeof this.props.settinginfos.year !== 'undefined' && parseInt(this.props.settinginfos.year, 10) < parseInt(thisYear.getFullYear(), 10) ) {
      return true;
    } else {
      return false;
    }
  }

  render() {
    if(typeof this.props.settinginfos !== 'undefined') {
      const {handleSubmit} = this.props
      return (
        <div>
            {this.renderAlert()}
            <form onSubmit={handleSubmit} style={styles.pt15} className='formFormat' >
              <div className="full">
                <Field
                  className={this.renderAutomatedDisabler() ? 'itsDisabled' : " "}
                  component={renderTextField}
                  floatingLabelText="év"
                  name="year"
                  disabled={this.renderAutomatedDisabler()}
                  style={{
                    display: "inline-block",
                    maxWidth: 320
                  }}
                  type="text"/>
              </div>
              <div className='flexContainer' style={{paddingTop: 60}}>
                <Paper zDepth={1}>
                  <Field
                    className="hidden"
                    style={{
                      display: 'none'
                    }}
                    component={renderTextField}
                    name="id"
                    type="hidden"
                  />
                  <Field
                    className={this.renderAutomatedDisabler() ? 'itsDisabled' : " "}
                    component={renderTextField}
                    floatingLabelText="pártoló tagdíj (Ft)"
                    name="supporter"
                    disabled={this.renderAutomatedDisabler()}
                    type="text"/>
                </Paper>
                <Paper zDepth={1}>
                  <Field
                    className={this.renderAutomatedDisabler() ? 'itsDisabled' : " "}
                    component={renderTextField}
                    floatingLabelText="rendes tagdíj (Ft)"
                    name="normal"
                    disabled={this.renderAutomatedDisabler()}
                    type="text"/>
                </Paper>
                <div style={{display: 'none'}}>
                  <Paper  zDepth={1} className='flexEnd p15'>
                    <RaisedButton className="PersonFormSubmitButton" type="submit" label="mentés" primary={true} labelColor={'#FFFFFF'}/>
                  </Paper>
                </div>
              </div>
            </form>
        </div>
      )
    } else{
      return (
        <div>
            {this.renderAlert()}
            <form>
              <div>
              </div>
            </form>
        </div>
      )
    }
  }
}

const validate = values => {
  const errors = {}

  if (values.password !== values.passwordConfirmation) {
    errors.password = 'Passwords must match'
  }
    /*
  if (!values.email) {
    errors.email = 'Please enter an email'
  }
    */
  if (!values.password) {
    errors.password = 'Please enter a password'
  }

  if (!values.passwordConfirmation) {
    errors.passwordConfirmation = 'Please confirm your password'
  }

  return errors
}

SettingForm = reduxForm({
  form: 'setting',
  validate
})(SettingForm)

// You have to connect() to any reducers that you wish to connect to yourself
SettingForm = connect(
  state => ({
    initialValues: state.settings.thissetting // pull initial values from reducer
  })//,
  //{ load: loadAccount }               // bind account loading action creator
)(SettingForm)

export default SettingForm


// WEBPACK FOOTER //
// ./src/components/settings/setting_form.js